module.exports = __webpack_public_path__ + "assets/d46cd4d023d6f60e223bddc71fc95de4.mp3";